import * as API from "@/api/rest";
import _ from 'lodash';

const path = "/app";
const relationId = "techkids";
const id = "1544814915334";

const namespaced = true;

const state = {
    app: null,
    currentEdit: null
};

const getters = {
    appGetter: state => state.app,
    currentEdit: state => state.currentEdit
};

const mutations = {
    getApp(state, request) {
        state.app = request.body.Items;
    },
    ADD_APP(state, payload) {
        state.app = [...state.app, payload.body.Item]
    },
    EDIT_APP(state, payload) {
        state.currentEdit = payload;
    },
    EDITED_APP(state, payload) {
        const indexItem = _.findIndex(state.app, { metaData: payload.metaData});
        state[indexItem] = payload;        
    }
};

const actions = {
    async callAppGetter({commit}, payload) {
        const res = await API.Get(`${path}?relationId=${relationId}&id=${id}&role=${payload.role}`);
        commit('getApp', res);
    },

    async callAppDelete({commit}, payload) {
        const body = {
            relationId: "techkids",
            id: "1544814915334",
            role: payload.role,
        }
        // console.log(payload);
        const res = await API.Delete(`${path}/${payload.item.metaData.name}`, { body });
    },

    async callAppAdd({commit}, payload) {
        const res = await API.Post(`${path}`, payload); 
        commit("ADD_APP", res);
    },

    getPackEditApp({commit}, payload) {
        commit("EDIT_APP", payload);
    },

    async callAppEdit({commit}, payload) {
        const res = await API.Put(`${path}/${payload.metaData.name}`, payload);
        commit("EDITED_APP", res);
    },
};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
}